document.addEventListener("DOMContentLoaded", function() {
    const bundleProductOptions = document.querySelectorAll('.custom-select.Type.Size .option');
    const bundleFrame = document.querySelectorAll('.custom-select.Frame');
    const bundleFrameOptions = document.querySelectorAll('.custom-select.Frame .option');
    const bundleMatboardOptions = document.querySelectorAll('.custom-select.Matboard .option');

    document.querySelectorAll(".custom-select .selected-option-title").forEach(function(selected) {
        selected.addEventListener("click", function(e) {
        e.stopPropagation();
        const customSelect = this.closest(".custom-select");

        document.querySelectorAll(".custom-select.open").forEach(function(cs) {
            if (cs !== customSelect) {
            cs.classList.remove("open");
            }
        });

        customSelect.classList.toggle("open");
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", function(e) {
        document.querySelectorAll(".custom-select.open").forEach(function(cs) {
        if (!cs.contains(e.target)) {
            cs.classList.remove("open");
        }
        });
    });

    document.querySelectorAll(".custom-select .option").forEach(function(option) {
        option.addEventListener("click", function(e) {
        e.stopPropagation();
        const customSelect = this.closest(".custom-select");
        const card = customSelect.closest(".gw-card");
        updateSelectedValue(this, customSelect, card);
        customSelect.classList.remove("open");
        });
    });

    function updateSelectedValue(option, customSelect) {
        const selected = customSelect.querySelector(".selected-option-title");

        // find the first visible option (display flex)
        const firstVisibleOption = Array.from(customSelect.querySelectorAll(".options .option"))
            .find(opt => opt.style.display === "flex");

        // clear existing content
        selected.innerHTML = "";

        // append first visible option content
        if (firstVisibleOption) {
            selected.innerHTML = firstVisibleOption.innerHTML;
        }

        // append the clicked option content
        selected.innerHTML = option.innerHTML;
    }

    // Attach to all remove buttons
    document.querySelectorAll('.gw-card .remove-btn .btn').forEach((btn) => {
        btn.addEventListener("click", () => {
        const productInfo = btn.closest(".gw-card").querySelector(".product-info-wrap");

        if (!productInfo) return;

        if (!productInfo.classList.contains('block-card')) {
            productInfo.classList.add('block-card');
            btn.textContent = "Restore";
        } 
        else {
            productInfo.classList.remove('block-card');
            btn.textContent = "Remove";
        }
        });
    });

    // Product Options Change
    bundleProductOptions.forEach((option) => {
        option.addEventListener("click", () => {
        const card = option.closest(".gw-card");
        updateProductOptions(option, card);
        price(card);
        });
    });

    // Frame Change
    bundleFrameOptions.forEach((option) => {
        option.addEventListener('click', () => {
        const card = option.closest(".gw-card");
        updateFrame(option.getAttribute('data-frame-image'), option, card);
        price(card);
        });
    });

    // Matboard Change
    bundleMatboardOptions.forEach((option) => {
        option.addEventListener('click', () => {
        const card = option.closest(".gw-card");
        updateMatboard(option.getAttribute('data-matboard-image'), option, card);
        price(card);
        });
    });

    function updateProductOptions(option, card) {
        const currentSelectedOption = card.querySelector('.custom-select.Type.Size .selected-option-title .option__label-text'); 
        const currentValue = currentSelectedOption.textContent.split('/');

        const type = currentValue[0].trim();   // "Poster"
        const size = currentValue[1].trim();   // "8x10 inch"

        const productBundleFrame = card.querySelector('.product-bundle-frame');
        if (!productBundleFrame) return;
        const mediaWrapper = productBundleFrame.closest('.media-wrapper');
        if (!mediaWrapper) return;
        
        mediaWrapper.style.maxWidth = '';

        const isMobile = window.innerWidth <= 768;
        const baseWidth = isMobile ? 84 : 80;
        const increment = 2;

        const selectedSize = size;
        const numericSize = parseInt(selectedSize);
        const selectedType = type;

        if (numericSize !== -1) {
        const newWidth = baseWidth + numericSize * increment;
        // mediaWrapper.style.maxWidth = `${newWidth}%`;
        } 

        const isCanvas = type === "Canvas";
        const bundleFrameImage = card.querySelector('.product-bundle-frame');
        const bundleMatboard = card.querySelector('.custom-select.Matboard');
        const bundleMatboardImage = card.querySelector('.product-bundle-matboard');
        const matboardhiddenInput = card.querySelector('input[name="bundle-matboard"]');
        const gwMediaSlide = card.querySelector('.media-wrapper');

        bundleMatboard?.classList.add("hidden");

        bundleMatboardImage.style.opacity = 0;
        bundleFrameImage.style.opacity = 0;
        gwMediaSlide?.classList.remove('matboardImage');
        gwMediaSlide?.classList.remove('frameImage');

        const frameOptions = card.querySelectorAll('.custom-select.Frame .option');
        frameOptions.forEach(frameOption => {
        const frameSize = frameOption.dataset.size;
        const frameType = frameOption.dataset.type;

        // Always show "No Frame" option
        if (frameOption.textContent.trim().toLowerCase() === "no frame") {
            frameOption.style.display = "flex";
            return;
        }

        // Show only matching size/type for other options
        if (selectedSize == frameSize && selectedType == frameType) {
            frameOption.style.display = "flex";
        } else {
            frameOption.style.display = "none";
        }
        });


        const matboardOptions = card.querySelectorAll('.custom-select.Matboard .option');
        matboardOptions.forEach(matboardOption => {
        const rawSize = matboardOption.dataset.size;
        if (!rawSize) {
            // skip this option if no data-size
            return;
        }
        const matboardSize = rawSize.toLowerCase();
        if (selectedSize.toLowerCase() !== matboardSize) {
            matboardOption.style.display = "none";
        } else {
            matboardOption.style.display = "flex";
        }
        });


        const varianthiddenInput = card.querySelector('input.bundle-var-id');
        const variantId = option.dataset.value;

        console.log(variantId, 'variantId');
        
        if (variantId) {
        varianthiddenInput.value = variantId;
        } 

        const frameSelect = card.querySelector('.custom-select.Frame');
        if (frameSelect) {
            const selectedTitle = frameSelect.querySelector('.selected-option-title');
            if (selectedTitle) {
                selectedTitle.innerHTML = "Choose Frame";
            }

            const frameHiddenInput = card.querySelector('input[name="bundle-frame"]');
            if (frameHiddenInput) {
                frameHiddenInput.value = "";
            }
        }

        const matboardSelect = card.querySelector('.custom-select.Matboard');
        if (matboardSelect) {
            const selectedTitle = matboardSelect.querySelector('.selected-option-title');
            if (selectedTitle) {
            selectedTitle.innerHTML = `<div class="option__label-text">Choose Matboard</div>`;
            }
            const matboardHiddenInput = card.querySelector('input[name="bundle-matboard"]');
            if (matboardHiddenInput) matboardHiddenInput.value = "";
        }
    }

    function updateFrame(src, option, card) {
        const currentSelectedOption = card.querySelector('.custom-select.Type.Size .selected-option-title .option__label-text'); 
        const currentValue = currentSelectedOption.textContent.split('/');

        const type = currentValue[0].trim();   // "Poster"
        const size = currentValue[1].trim();   // "8x10 inch"

        const isCanvas = type === "Canvas";

        const variantId = option.dataset.value;
        const variantTitle = option.querySelector(".option__label-text .text")?.innerText.trim() || "";
        const variantPrice = option.querySelector(".option__label-price .sale-price")?.innerText || option.innerText;
        const variantComparePrice = option.querySelector(".option__label-price .compare-price")?.innerText || option.innerText;

        const framehiddenInput = card.querySelector('input[name="bundle-frame"]');
        const bundleFrameImage = card.querySelector('.product-bundle-frame');
        const bundleMatboardImage = card.querySelector('.product-bundle-matboard');
        const gwMediaSlide = card.querySelector('.media-wrapper');
        const bundleMatboard = card.querySelector('.custom-select.Matboard');

        // Update frame hidden input
        if (variantId) {
            framehiddenInput.value = variantId;
            framehiddenInput.setAttribute('data-frame-title', variantTitle);
            framehiddenInput.setAttribute('data-frame-price', parseFloat(variantPrice.replace(/[^0-9.]/g, '')) || 0);
            framehiddenInput.setAttribute('data-frame-compare-price', parseFloat(variantComparePrice.replace(/[^0-9.]/g, '')) || 0);
        } else {
            framehiddenInput.value = "";
            framehiddenInput.setAttribute('data-frame-title', '');
            framehiddenInput.setAttribute('data-frame-price', 0);
            framehiddenInput.setAttribute('data-frame-compare-price', '');
        }

        if (src) {
            bundleFrameImage.src = src;
            bundleFrameImage.style.opacity = 1;
            gwMediaSlide?.classList.add('frameImage');

            if (!isCanvas) {
                bundleMatboard?.classList.remove('hidden');

                const selectedLabel = bundleMatboard?.querySelector('.selected-option-title .text')?.textContent?.trim().toLowerCase();
                const hasValidImage = bundleMatboardImage?.src?.trim() && !bundleMatboardImage.src.endsWith("/");

                if (selectedLabel && selectedLabel !== "no matboard" && hasValidImage) {
                    bundleMatboardImage.style.opacity = 1;
                    gwMediaSlide?.classList.add('matboardImage');
                } else {
                    bundleMatboardImage.style.opacity = 0;
                    gwMediaSlide?.classList.remove('matboardImage');
                }
            }
            else {
                bundleMatboard?.classList.add('hidden');
                bundleMatboardImage.style.opacity = 0;
                gwMediaSlide?.classList.remove('matboardImage');
            }
        } 
        else {
            bundleFrameImage.style.opacity = 0;
            bundleMatboardImage.style.opacity = 0;
            bundleMatboard?.classList.add('hidden');
            gwMediaSlide?.classList.remove('frameImage');
            gwMediaSlide?.classList.remove('matboardImage');
        }
    }

    function updateMatboard(src, option, card) {
        const currentSelectedType = card.querySelector('.custom-select.Type .selected-option-title'); 
        const currentSelectedTypeValue = currentSelectedType?.textContent; 
        const isCanvas = currentSelectedTypeValue?.trim() === "Canvas";

        const variantId = option.dataset.value;
        const variantTitle = option.querySelector(".option__label-text .text")?.innerText.trim() || "";
        const variantPrice = option.querySelector(".option__label-price .sale-price")?.innerText || option.innerText;
        const variantComparePrice = option.querySelector(".option__label-price .compare-price")?.innerText || option.innerText;

        const matboardhiddenInput = card.querySelector('input[name="bundle-matboard"]');
        const bundleMatboardImage = card.querySelector('.product-bundle-matboard');
        const gwMediaSlide = card.querySelector('.media-wrapper');
        const bundleMatboard = card.querySelector('.custom-select.Matboard');

        if (variantId) {
        matboardhiddenInput.value = variantId;
        matboardhiddenInput.setAttribute('data-matboard-title', variantTitle);
        matboardhiddenInput.setAttribute('data-matboard-price', parseFloat(variantPrice.replace(/[^0-9.]/g, '')) || 0);
        matboardhiddenInput.setAttribute('data-matboard-compare-price', parseFloat(variantComparePrice.replace(/[^0-9.]/g, '')) || 0);
        } else {
        matboardhiddenInput.value = "";
        matboardhiddenInput.setAttribute('data-matboard-title', '');
        matboardhiddenInput.setAttribute('data-matboard-price', 0);
        matboardhiddenInput.setAttribute('data-matboard-compare-price', '');
        }

        if (src) {        
        bundleMatboardImage.src = src;
        bundleMatboardImage.style.opacity = 1;
        if (!isCanvas) {
            bundleMatboard?.classList.remove('hidden');
            gwMediaSlide?.classList.add('matboardImage');
        } else {          
            bundleMatboard?.classList.add('hidden');
            gwMediaSlide?.classList.remove('matboardImage');
        }
        } else {
            bundleMatboardImage.src = "";
            bundleMatboardImage.style.opacity = 0;
            gwMediaSlide?.classList.remove('matboardImage');
        }
    }

    function price(card) {
        const mainPriceEl = card.querySelector('.custom-select.Type.Size .selected-option-title .sale-price');
        const framePriceEl = card.querySelector('.custom-select.Frame .selected-option-title .sale-price');
        const matboardPriceEl = card.querySelector('.custom-select.Matboard .selected-option-title .sale-price');
        const totalCartPrice = card.querySelector('.product-form__buttons .totalCartPrice');

        const mainPrice = parseFloat(mainPriceEl?.textContent.replace(/[^0-9.]/g, "")) || 0;
        const framePrice = parseFloat(framePriceEl?.textContent.replace(/[^0-9.]/g, "")) || 0;
        const matboardPrice = parseFloat(matboardPriceEl?.textContent.replace(/[^0-9.]/g, "")) || 0;

        const totalPrice = mainPrice + framePrice + matboardPrice;

        console.log({ mainPrice, framePrice, matboardPrice, totalPrice }); // debug

        const currencyCode = "USD"; // make sure this is set correctly

        totalCartPrice.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
        }).format(totalPrice);
    }
});

document.getElementById("add-all-to-cart").addEventListener("click", async function(e) {
  e.preventDefault();

  const buttons = document.querySelectorAll(".gw-card .product-info-wrap:not(.block-card) .product-form__submit");

  for (let i = 0; i < buttons.length; i++) {
    const btn = buttons[i];
    btn.click();
    console.log("Triggered add-to-cart for card", i + 1);
    await new Promise(resolve => setTimeout(resolve, 3000)); 
  }
});
